import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import home from '@/mocks/zh/home';
import { articles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'article-guide-01': 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20professional%20illustration%20with%20warm%20cream%20and%20golden%20tones%2C%20soft%20geometric%20patterns%2C%20clean%20modern%20corporate%20aesthetic%2C%20premium%20luxurious%20brand%20visual%2C%20subtle%20texture%2C%20no%20text%2C%20no%20people&width=600&height=375&seq=article-guide-01&orientation=landscape',
  'article-security-01': 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20shield%20and%20lock%20themed%20illustration%20with%20warm%20amber%20and%20cream%20colors%2C%20soft%20geometric%20shapes%2C%20clean%20corporate%20style%2C%20trustworthy%20and%20secure%20mood%2C%20no%20text%2C%20no%20people&width=600&height=375&seq=article-security-01&orientation=landscape',
  'article-news-01': 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20upgrade%20and%20innovation%20themed%20illustration%20with%20warm%20golden%20gradients%2C%20clean%20corporate%20style%2C%20modern%20and%20fresh%20aesthetic%2C%20no%20text%2C%20no%20people&width=600&height=375&seq=article-news-01&orientation=landscape',
  'article-faq-01': 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20question%20mark%20and%20dialogue%20themed%20illustration%20with%20soft%20warm%20tones%2C%20geometric%20clean%20design%2C%20friendly%20and%20helpful%20vibe%2C%20no%20text%2C%20no%20people&width=600&height=375&seq=article-faq-01&orientation=landscape',
  'article-service-01': 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20headset%20and%20support%20themed%20illustration%2C%20warm%20amber%20and%20cream%20palette%2C%20soft%20geometric%20design%2C%20professional%20corporate%20style%2C%20no%20text%2C%20no%20people&width=600&height=375&seq=article-service-01&orientation=landscape',
  'article-exp-01': 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20star%20and%20review%20themed%20illustration%20with%20warm%20golden%20tones%2C%20soft%20geometric%20patterns%2C%20positive%20and%20trustworthy%20mood%2C%20no%20text%2C%20no%20people&width=600&height=375&seq=article-exp-01&orientation=landscape',
  'article-mobile-01': 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20mobile%20phone%20and%20app%20themed%20illustration%2C%20warm%20amber%20and%20cream%20gradients%2C%20geometric%20clean%20design%2C%20modern%20tech%20corporate%20style%2C%20no%20text%2C%20no%20people&width=600&height=375&seq=article-mobile-01&orientation=landscape',
  'article-phishing-01': 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20warning%20and%20security%20themed%20illustration%20with%20warm%20golden%20and%20amber%20tones%2C%20geometric%20patterns%2C%20alert%20but%20calm%20mood%2C%20no%20text%2C%20no%20people&width=600&height=375&seq=article-phishing-01&orientation=landscape',
};

export default function Home() {
  const stats = [
    { value: '100万+', label: home.stats.users, icon: 'ri-user-line' },
    { value: '98.5%', label: home.stats.satisfaction, icon: 'ri-heart-line' },
    { value: '24h', label: home.stats.supportHours, icon: 'ri-time-line' },
    { value: '<3分钟', label: home.stats.responseTime, icon: 'ri-speed-up-line' },
  ];

  const latestArticles = articles.slice(0, 4);

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20minimalist%20background%20with%20warm%20golden%20and%20cream%20toned%20flowing%20gradient%20shapes%2C%20soft%20elegant%20atmospheric%20lighting%2C%20modern%20clean%20corporate%20aesthetic%2C%20subtle%20texture%20overlay%2C%20luxurious%20and%20trustworthy%20mood%2C%20no%20text%2C%20no%20people%2C%20smooth%20curves%20and%20organic%20color%20transitions%2C%20high%20end%20premium%20feel&width=1600&height=900&seq=hero-kaiyun-01&orientation=landscape"
            alt="开云平台背景"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50" />

          <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20">
            <div className="flex flex-col items-center text-center">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
                <i className="ri-shield-check-line text-accent-300 text-sm" />
                <span className="text-xs font-medium text-background-50/90">安全可信赖的首选平台</span>
              </div>
              <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 mb-5 tracking-tight">
                {home.hero.title}
              </h1>
              <p className="text-lg md:text-xl text-background-50/80 max-w-2xl leading-relaxed mb-8">
                {home.hero.description}
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-4">
                <Link
                  to="/categories"
                  className="px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
                >
                  {home.hero.cta}
                </Link>
                <Link
                  to="/about"
                  className="px-8 py-3.5 rounded-lg border border-background-50/40 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap"
                >
                  {home.hero.secondaryCta}
                </Link>
              </div>
            </div>
          </div>

          <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent" />
        </section>

        <section className="w-full bg-background-50 py-16 md:py-20">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {stats.map((stat, index) => (
                <div key={index} className="flex flex-col items-center text-center p-6 rounded-xl bg-background-100/80">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 mb-4">
                    <i className={`${stat.icon} text-accent-600 text-xl`} />
                  </div>
                  <span className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">{stat.value}</span>
                  <span className="text-sm text-foreground-500 mt-1">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full bg-background-100/70 py-16 md:py-20">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
                {home.features.title}
              </h2>
              <p className="text-foreground-500 text-sm md:text-base">{home.features.subtitle}</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {home.features.items.map((feature, index) => (
                <div
                  key={index}
                  className="group p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 mb-4 group-hover:bg-primary-200 transition-colors">
                    <i className={`${feature.icon} text-primary-600 text-xl`} />
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 mb-2 text-base">{feature.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full bg-background-50 py-16 md:py-20">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex flex-col sm:flex-row items-center justify-between mb-12">
              <div>
                <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
                  {home.latestArticles.title}
                </h2>
                <p className="text-foreground-500 text-sm md:text-base">{home.latestArticles.subtitle}</p>
              </div>
              <Link
                to="/articles"
                className="mt-4 sm:mt-0 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line" />
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {latestArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/articles/${article.slug}`}
                  className="group rounded-xl bg-background-100/80 overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300"
                >
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={articleImages[article.imageSeq]}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-2 mb-3">
                      <span className="text-xs px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium">
                        {article.categoryName}
                      </span>
                      <span className="text-xs text-foreground-400">{article.publishedAt}</span>
                    </div>
                    <h3 className="font-heading font-semibold text-foreground-900 mb-2 text-sm leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{article.summary}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full bg-background-100/70 py-16 md:py-20">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
                {home.faq.title}
              </h2>
              <p className="text-foreground-500 text-sm md:text-base">{home.faq.subtitle}</p>
            </div>
            <div className="max-w-3xl mx-auto flex flex-col gap-3">
              {home.faq.items.map((item, index) => (
                <details key={index} className="group rounded-xl bg-background-50 border border-background-200/60">
                  <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                    <span className="font-medium text-foreground-800 text-sm pr-4">{item.question}</span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform text-lg flex-shrink-0" />
                  </summary>
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-500 leading-relaxed">{item.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full bg-accent-500 py-16 md:py-20">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
              {home.cta.title}
            </h2>
            <p className="text-background-50/80 text-sm md:text-base mb-8">
              {home.cta.subtitle}
            </p>
            <Link
              to="/categories"
              className="inline-flex px-8 py-3.5 rounded-lg bg-background-50 text-accent-600 font-semibold text-sm hover:bg-background-50/90 transition-all duration-200 whitespace-nowrap"
            >
              {home.cta.button}
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}